module.exports = "/_next/static/images/AIAnnouncements@2x-ac87dac0fd7cd7a8570c9c469c5ff3d5.webp";